import React from "react";
import "./blue_checkmark.scss";
const BlueCheckmark = () => {
  return <div className={"blue-checkmark"} />;
};

export default BlueCheckmark;
